import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchDpads, sendProvisioningCommand } from "./endpoints";
export const useHitDecoder = (customerId) => {
    const { data: dpads, isLoading, isFetching, isError, error, } = useQuery({
        queryKey: ['dpads', customerId],
        queryFn: () => fetchDpads(customerId),
        enabled: !!customerId,
    });
    const sendCommandMutation = useMutation(({ deviceId, command }) => sendProvisioningCommand({ deviceId, command }));
    const sendCommand = async (selectedDevice, selectedCommand) => {
        var _a, _b;
        if (!selectedDevice || !selectedCommand)
            return;
        try {
            await sendCommandMutation.mutateAsync({
                deviceId: selectedDevice.value,
                command: selectedCommand.value,
            });
            return {
                success: true,
                message: `Successfully sent ${selectedCommand.label} to ${selectedDevice.label}`,
            };
        }
        catch (err) {
            return {
                success: false,
                message: ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
                    "Failed to send provisioning command",
            };
        }
    };
    return {
        dpads,
        isLoading,
        isFetching,
        isError,
        error,
        sendCommand,
        isSending: sendCommandMutation.isLoading,
        isSendCommandError: sendCommandMutation.isError,
        sendCommandError: sendCommandMutation.error,
    };
};
